import React from "react";
import { Link } from "gatsby";
import cx from "classnames";
import { StaticImage } from "gatsby-plugin-image";

type Props = {
  className?: string;
};

function onClick() {
  if (typeof window !== "undefined") {
    (window as any).dataLayer.push({
      event: "click_book_promotion",
    });
  }
}

function Tagline({ className }: Props) {
  return (
    <div
      className={cx(
        className,
        "mt-4 relative bg-neutral-99 overflow-visible border-t border-b border-[#F0F0F0]"
      )}
    >
      <div className="bg-banner relative z-10 mx-auto px-4 flex flex-col items-center sm:-ml-[120px]">
        <div className="flex items-center max-h-[90px] sm:max-h-[123px]">
          <a
            onClick={(e) => onClick(e)}
            href="https://www.amazon.co.jp/dp/4798190888"
            target="_blank"
            rel="sponsored noreferrer"
          >
            <StaticImage
              src="../../../assets/images/book.png"
              alt="デジタルプロダクトデザインの教科書"
              // width={134}
              className="w-[100px] sm:w-[134px]"
            />
          </a>
          <div className="flex flex-col gap-2 sm:gap-4 items-start sm:items-center">
            {/* Text content */}
            <div className="flex flex-col gap-2 sm:items-center sm:text-center">
              <p className="text-sm font-bold text-black leading-tight">
                デジタルプロダクトデザインの実践書が発売
              </p>
              <p className="text-xs font-regular text-black leading-tight hidden sm:block">
                ビジネス成果につながる論理的なデザイン施策のプロセスが学べる！
              </p>
            </div>

            {/* CTA Button */}
            <a
              onClick={(e) => onClick(e)}
              href="https://www.amazon.co.jp/dp/4798190888"
              target="_blank"
              rel="sponsored noreferrer"
              className="bg-black text-white px-3 py-1.5 rounded-full text-2xs font-regular hover:opacity-90 transition-colors duration-200 flex items-center gap-1"
            >
              <span>
                <span>Amazonで購入</span>
                <span className="hidden sm:inline">して受け取る</span>
              </span>
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.85449 6.5H10.1447"
                  stroke="white"
                  strokeWidth="1.04146"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.5 2.85498L10.1451 6.5001L6.5 10.1452"
                  stroke="white"
                  strokeWidth="1.04146"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tagline;
